<template>
    <div>
        <div class="loader" v-if="form.busy">
            <img src="/img/spinner.svg" alt="">
        </div>
        <form @submit.prevent="submit">
            <textarea-field placeholder="Enter blog title"  :errors="form.errors.get('title')" v-model="form.title" :form="form" :rows="2" name="title3">Blog title (up to 140
                characters)
            </textarea-field>

            <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-12 mt-4">
<!--                    <input-field :errors="form.errors.get('first_name')" v-model="form.first_name">Date</input-field>-->
<!--                    <date-field placeholder="Enter date" :form="form" name="date" :errors="form.errors.get('date_formatted')" v-model="form.date_formatted">Date</date-field>-->
                    <div>
                        <label class="form-label" for="field">
                            Deadline
                        </label>
                        <Datepicker id="field" :class="{'invalid': form.errors.has('deadline')}"
                                    ref="datePicker"
                                    v-model="form.deadline" class="form-control date-picker" placeholder="Enter date" type="text"
                                    format="DD.MM.YYYY."
                                    lang="en"
                                    readonly
                                    :key="componentkey"
                                    required
                        />

                        <div class="text-danger text-center">
                            {{ form.errors.get('deadline') }}
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 mt-4">
                    <input-field-image name="location3" placeholder="Enter location" :errors="form.errors.get('location')" v-model="form.location">Location</input-field-image>

                </div>
            </div>

            <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-12 mt-4">
                    <input-field name="costs3" min="0" step="any" type="number" placeholder="Enter cost" :errors="form.errors.get('costs')" v-model="form.costs">Cost</input-field>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 mt-4">
                    <input-field name="scholarship3" placeholder="Enter scholarship" :errors="form.errors.get('scholarship')" v-model="form.scholarship">Scholarship</input-field>
                </div>
            </div>

            <input-field name="organiser3" placeholder="Enter organiser" :errors="form.errors.get('organiser')" v-model="form.organiser" :form="form" class="mt-4">Organiser
            </input-field>

            <textarea-field :maxlen="2500" placeholder="Enter description" :errors="form.errors.get('description')" v-model="form.description" :form="form" :rows="12" class="mt-4" name="description3">Description
            </textarea-field>

            <textarea-field placeholder="Enter more info" :errors="form.errors.get('more_info')" v-model="form.more_info" :form="form" :rows="6" class="mt-4" name="more_info3">More info
            </textarea-field>

            <input-field name="website3" placeholder="https://www." :errors="form.errors.get('website')" v-model="form.website" class="mt-4">Official website</input-field>

            <image-field :key="imageKey" ref="imageField" :errors="form.errors.get('image')" v-model="form.image" class="mt-5 mb-5" cover subtitle="PNG, JPG (up to 2MB)">Upload your
                photo
            </image-field>

<!--            USER-->
            <image-field :key="imageKey2" ref="imageField" :errors="form.errors.get('photo')" v-model="form.photo" class="mt-5 mb-5" subtitle="Square format, up to 500kb">Upload your
                photo
            </image-field>
            <div class="row ">
                <div class="col-lg-6 col-md-12 col-sm-12 mt-4">
                    <input-field name="first_name3" placeholder="Marko" :errors="form.errors.get('first_name')" v-model="form.first_name">First name</input-field>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 mt-4">
                    <input-field name="last_name3" placeholder="Marković" :errors="form.errors.get('last_name')" v-model="form.last_name">Last name</input-field>
                </div>
            </div>
            <input-field name="email3" placeholder="marko.markovic@gmail.com" :errors="form.errors.get('email')" type="email" v-model="form.email" class="mt-4">Email</input-field>
            <textarea-field :maxlen="500" placeholder="Enter your bio" :errors="form.errors.get('biography')" v-model="form.biography" :form="form" :rows="4" class="mt-4" name="biography3">Short bio
            </textarea-field>


            <p class="mt-3">Please do not submit your information more than once. Thank you!</p>
            <div class="w-100 d-flex-center mt-3">
                <button :disabled="form.busy" class="tag-opportunities">Send</button>
            </div>
        </form>
    </div>
</template>

<script>
import InputField from "./client-form/InputField";
import InputFieldImage from "./client-form/InputFieldImage";
import TextareaField from "./client-form/TextareaField";
import ImageField from "./client-form/ImageField";
import Form from 'vform'
import objectToFormData from '@admin/objectToForm';
import DateField from "./client-form/DateField";
import SelectField from "./admin/forms/SelectField";
import 'vue-datepicker-ui/lib/vuedatepickerui.css';
import VueDatepickerUi from 'vue-datepicker-ui';

export default {
    name: "OpportunitiesForm",
    components: {SelectField, DateField, ImageField, TextareaField,InputFieldImage, InputField, Datepicker: VueDatepickerUi},
    data: function () {
        return {
            form: new Form({
                first_name: '',
                title: '',
                last_name: '',
                email: '',
                biography: '',
                text: '',
                country_id: 0,
            }),
            componentkey: 0,
            imageKey: 1,
            imageKey2: 2,
            countries: [
                {name: 'Bosnia and Hercegovina', id: 1},
                {name: 'Montenegro', id: 2},
                {name: 'Albania', id: 3},
                {name: 'North Macedonia', id: 4},
                {name: 'Kosovo*', id: 5},
                {name: 'Serbia', id: 6},
            ]
        }
    },
    methods: {
        submit() {
            if(this.form.deadline)
                this.form.deadline = this.$moment(this.form.deadline).format('YYYY-MM-DD');
            this.form.submit('post', (route('opportunities.guest.store')), {
                transformRequest: [function (data, headers) {
                    return objectToFormData(data)
                }]
            }).then(res => {
                this.form.reset();
                this.$toast.success("Your message has been sent!", {
                    position: "top-right",
                    timeout: 5000,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: true,
                    closeButton: "button",
                    icon: true,
                    rtl: false
                });
                Bus.$emit("reset-preview");
                this.componentkey ++;
                this.imageKey ++;
                this.imageKey2 ++;
                // this.$refs.datePicker.$data. = null;
                document.querySelector('button.close-opp').click();
            }).catch(() => {
                const container = document.querySelector('.opp-body');
                const items = container.getElementsByClassName('invalid');
                const visible = [...items].filter((el) => {
                    // jQuery-like :visible selector
                    return !!( el.offsetWidth || el.offsetHeight || el.getClientRects().length );
                });

                if (visible.length > 0) {
                    container.scrollTo({
                        top: items[0].offsetTop - 100,
                        behavior: 'smooth'
                    });
                }
            })
        },
    },
    mounted() {
        document.querySelector('button.close-opp').onclick = () => {
            this.form.reset();
            this.componentkey ++;
            Bus.$emit("reset-preview");
        };
    }
}
</script>
<style lang="scss" scoped>

.invalid{
    border-color: #dc3545!important;
    padding-right: calc(1.5em + 0.75rem) !important;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right calc(0.375em + 0.1875rem) center;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.v-calendar .input-field input {
    height: unset!important;
    border: none!important;
    //padding: unset!important;
    padding-left: 0!important;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 1rem!important;
}

.v-calendar .input-field svg.datepicker {
    right: 10px!important;
    left: unset!important;
    fill: #827DA9FF!important;
}
.form-control:disabled, .form-control[readonly] {
    background-color: transparent!important;
    opacity: 1;
}
.v-calendar {
    width: 100% !important;
}
.location {
    position: relative;
    img {
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
    }
}
</style>
<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/mixins";

input,.v-calendar,select {
    padding: 15px 20px;
    border-radius: 15px;
    border: 1px solid rgba(109, 110, 112, 0.5);
    &::placeholder {
        @include font($mulish-light, 18px, 30px, $hajde-black);
        opacity: 50%;
    }
}


.loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.94);
    display: grid;
    place-items: center;
    z-index: 1000;
}
button:disabled {
    opacity: 0.6!important;
    cursor: not-allowed!important;
}


p {
    width: 100%;
    text-align: center;
    @include font($mulish-light, 18px, 30px, $hajde-black);
    opacity: 50%;
}

button {
    text-align: center;
    border: none;
    background-color: $hajde-sky;
    border-radius: 10px;
    padding: 1rem 1.6rem;
    text-transform: uppercase;
    margin-bottom: 1rem;
    @include font($mulish-bold, 18px, 18px, white);
}
</style>
